import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const StyledSubtitleTypography = styled(Typography)`
  margin-bottom: ${({ theme }) => theme.spacing(5)};
`;
